import styled from './erroacesso.module.css';
import { CiMail } from 'react-icons/ci';
import { BsWhatsapp } from 'react-icons/bs';
import {useNavigate} from 'react-router-dom';


function ErroAcesso() {
    
    const Navigate = useNavigate();
    function Login(){
        Navigate('/')
    }
    
    return (
        <div className={styled.page}>
            <div className={styled.container}>
                <div className={styled.logo}>
                    <div className={styled.logoimg}></div>
                </div>
                <div className={styled.card}>
                    <div className={styled.cardcontent}>
                        <div className={styled.app}>
                            <div className={styled.frame101}>
                                <div className={styled.frame101img}></div>
                            </div>
                            <a>O endereço de e-mail não está cadastrado para este CNPJ.</a>
                            <a>Verifique se o CNPJ está correto ou se o endereço de e-mail é o mesmo informado na sua última compra.</a>
                            <a>Caso o problema persista entre em contato com a Cozimax</a>
                            <div className={styled.atendimento}>
                                <div className={styled.emailcontent}>
                                    <CiMail size={28} />
                                    <a>atendimento@cozimax.com.br</a>
                                </div>
                                <div className={styled.telcontent}>
                                    <BsWhatsapp className={styled.iconwats} size={15} />
                                    <a>(17) 97400-4099</a>
                                </div>
                            </div>
                            <div onClick={()=>Login()} className={styled.btn}>VOLTAR PARA LOGIN</div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}


export default ErroAcesso;